import { ErrorHandler, Injectable, inject } from '@angular/core';

import { FlamingoMessageService } from './flamingo-message.service';

@Injectable({
    providedIn: 'root'
})
export class FlamingoErrorHandler implements ErrorHandler {
    private readonly messageService = inject(FlamingoMessageService);

    handleError(error: unknown): void {
        console.error('[FlamingoErrorHandler]', error);
        this.messageService.error('Si è verificato un errore inatteso. Riprova più tardi.');
    }
}



